<template>
  <contact-form-fieldset
    class="contact-form__meeting-length"
    class-content-wrapper="contact-form__radio-buttons-horizontal"
    :legend="texts.meetingLength"
    :tooltip="meetingLengthTooltip"
    :required="true"
  >
    <div
      v-for="(title, type) in prices"
      :key="type"
      :class="{ 'contact-form-radio-button--active': priceModel === type }"
      class="radio-button contact-form-radio-button"
      @click="priceModel = type"
    >
      <input
        :id="type"
        v-model="priceModel"
        :value="type"
        type="radio"
        name="price"
        class="contact-form-radio-button__input"
      />
      <label
        :for="type"
        class="marker contact-form-radio-button__label"
        v-html="title"
      />
    </div>
  </contact-form-fieldset>
</template>

<script>
import ContactFormFieldset from './ContactFormFieldset.vue';

export default {
  name: 'MeetingLength',

  components: {
    ContactFormFieldset,
  },

  props: {
    price: {
      type: String,
      default: '',
    },
    prices: {
      type: Object,
      default: () => ({}),
    },
    meetingType: {
      type: String,
      default: '',
    },
    requestType: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      texts: theme_vars.contactTexts,
    };
  },

  computed: {
    meetingLengthTooltip() {
      return theme_vars?.tooltip[this.requestType]?.meetingLength;
    },

    priceModel: {
      get() {
        return this.price;
      },
      set(value) {
        this.$emit('update:price', value);
      },
    },
  },

  watch: {
    meetingType(value) {
      if (value) {
        this.priceModel = Object.keys(this.prices)[0];
      }
    },
  },

  created() {
    if (!this.price) {
      this.priceModel = Object.keys(this.prices)[0];
    }
  },
};
</script>
